/* eslint-disable no-prototype-builtins */
/* globals Event */

import {
  withHTMLComponent,
  applyAsAttributes,
} from '@updater-legacy/components/custom-element';
import '@updater-legacy/components/popup';
import '@updater-legacy/components/focus-out';
import '@updater-legacy/components/focus-trap';

const html = `
<upd-focus-out class="upd-datepicker-focus-out">
  <upd-focus-trap>
    <upd-popup class="upd-datepicker-popup">
      <div class="upd-datepicker-popup-content">
        <upd-datepicker focus-selected-date></upd-datepicker>
      </div>
    </upd-popup>
  </upd-focus-trap>
</upd-focus-out>
`;

const css = `
:host {
  display: block;
}

.upd-datepicker-popup-content {
  background: white;
  position: absolute;
  height: 18.75em;
  top: 0.625em;
  padding: 1.25em;
  box-shadow: 0 0.3125em 0.3125em -0.1875em rgba(0, 0, 0, 0.2),
    0 0.5em 0.625em 0.0625em rgba(0, 0, 0, 0.14),
    0 0.1875em 0.875em 0.125em rgba(0, 0, 0, 0.12);
  opacity: 0;
  transition: opacity 0.3s;
}

.upd-datepicker-popup[open] .upd-datepicker-popup-content {
  opacity: 1;
}
`;

class DatepickerPopup extends withHTMLComponent(css, html)() {
  static observedAttributes = ['value', 'min', 'max', 'open'];

  static reflectedAttributes = ['value', 'min', 'max'];

  constructor() {
    super();

    this._popup = this.shadowRoot.querySelector('upd-popup');
    this._datepicker = this.shadowRoot.querySelector('upd-datepicker');
    this._focusOut = this.shadowRoot.querySelector('upd-focus-out');
    this._focusTrap = this.shadowRoot.querySelector('upd-focus-trap');
  }

  connected() {
    this._focusOut.disabled = true;
  }

  _handleFocusOut = () => this.close();

  _handleChange = () => {
    this.value = this._datepicker.value;
    this.close();
  };

  _handleClose() {
    this._popup.close();
    this.dispatchEvent(new Event('close'));
    this._focusOut.disabled = true;
    this._focusOut.removeEventListener('updfocusout', this._handleFocusOut);
    this._datepicker.removeEventListener('change', this._handleChange);
  }

  _handleOpen() {
    this._focusOut.disabled = false;
    this._popup.open();
    this._focusTrap.focus();
    this._focusOut.addEventListener('updfocusout', this._handleFocusOut);
    this._datepicker.addEventListener('change', this._handleChange);
  }

  updated({ value, min, max }) {
    applyAsAttributes(this._datepicker, {
      value,
      min,
      max,
    });

    if (this.opened) {
      this._handleOpen();
    } else {
      this._handleClose();
    }
  }

  set enabledDates(value) {
    this._datepicker.enabledDates = value;
  }

  get enabledDates() {
    return this._datepicker.enabledDates;
  }

  set disabledDates(value) {
    this._datepicker.disabledDates = value;
  }

  get disabledDates() {
    return this._datepicker.disabledDates;
  }

  get opened() {
    return this.hasAttribute('open');
  }

  open() {
    if (!this.opened) {
      this.setAttribute('open', '');
    }
  }

  close() {
    if (this.opened) {
      this.removeAttribute('open');
    }
  }
}

window.customElements.define('upd-datepicker-popup', DatepickerPopup);
